import { ScheduleInterview } from '../scheduleInterview';
import { InterviewStep } from '../interviewStep';


export class InterviewStepSerializer {
    fromJson(json: any): any {
        const data = new InterviewStep();
    data.interviewId = json.interviewId,
         data.id= json.id,
         data.interviewStep= json.interviewStep,
         data.interviewStepStatus=json.interviewStepStatus,
         data.interviewer = json.interviewer,
         data.interview=json.interview,
         data.notes=json.notes,
         data.user= json.user,
         data.comment= json.comment,
         data.interviewMode=json.interviewMode,
         data.scheduledById=json.scheduledById,
         data.mailSentOrNot=json.mailSentOrNot,
         data.primaryRecruiter=json.primaryRecruiter,
         data.showPreviousFeedback=json.showPreviousFeedback
        return data;
    }

    toJson(data: InterviewStep): any {
        return {

           id: data.id,
           interviewId :data.interviewId,
           startDate :data.date,
            interviewer :data.interviewerObj,
           interviewStep :data.interviewStep,
           user:data.user,
           pass:data.pass,
           notes:data.notes,
           startTime:data.startTime,
            interviewStepStatus:data.interviewStepStatus,
            //interview :data.interview,
            comment:data.comment,
            //user: data.user
            interviewMode:data.interviewMode,
            scheduledById:data.scheduledById,
            primaryRecruiter:data.primaryRecruiter,
            mailSentOrNot:data.mailSentOrNot,
            showPreviousFeedback:data.showPreviousFeedback
            
        };
    }
}